import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Supabase email confirmation redirects to Site URL / redirect_to with tokens in the hash.
 * Normalize any path + #access_token=... to /auth/callback so one page can complete login.
 */
export default function SupabaseHashRedirect() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const hash = window.location.hash;
    if (!hash || hash.length < 2 || !hash.includes('access_token=')) return;
    if (location.pathname === '/auth/callback') return;
    navigate(`/auth/callback${hash}`, { replace: true });
  }, [location.pathname, navigate]);

  return null;
}
